import { WorkerStage } from "@clipboard-health/contract-worker-app-bff";
import { isDefined } from "@clipboard-health/util-ts";
import { ThemeProvider } from "@mui/material";
import { RootPaths } from "@src/appV2/App/paths";
import { useGetClipboardScoreHistory } from "@src/appV2/ClipboardScore/api/useGetClipboardScoreHistory";
import { useGetClipboardScoreProfile } from "@src/appV2/ClipboardScore/api/useGetClipboardScoreProfile";
import type { UseModalState } from "@src/appV2/redesign/system/ui-components";
import { getTheme } from "@src/appV2/redesign/system/ui-theme";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";
import { useHistory } from "react-router-dom";

import { type ClipboardScoreActions } from "../../utils/constants";
import { RestrictedNudgeBottomSheetContent } from "./RestrictedNudgeBottomSheetContent";

interface RestrictedNudgeBottomSheetProps {
  modalState: UseModalState;
  action:
    | ClipboardScoreActions.NO_CALL_NO_SHOW
    | ClipboardScoreActions.WORKER_LEFT_EARLY_WITHOUT_PERMISSION;
}

export function RestrictedNudgeBottomSheet(props: RestrictedNudgeBottomSheetProps) {
  const { modalState, action } = props;

  const history = useHistory();
  const { userId } = useDefinedWorker();
  const { data: clipboardScoreProfile } = useGetClipboardScoreProfile(userId, {
    enabled: modalState.modalIsOpen,
  });
  const { data: clipboardScoreHistory } = useGetClipboardScoreHistory(
    {
      userId,
      pageSize: 1,
    },
    { enabled: modalState.modalIsOpen }
  );

  const currentStatus = clipboardScoreProfile?.accountStatus?.status;
  const lastScoreLog = clipboardScoreHistory?.scoreLogs?.at(-1);

  const currentScore = clipboardScoreProfile?.clipboardScore ?? 0;
  const scoreChange = lastScoreLog?.clipboardScoreAdjustment ?? 0;

  const showBottomSheet =
    currentStatus === WorkerStage.RESTRICTED &&
    isDefined(lastScoreLog) &&
    lastScoreLog.action === action;

  if (!showBottomSheet) {
    return null;
  }

  const onContinue = (): void => {
    history.push(RootPaths.HOME);
  };

  return (
    <ThemeProvider theme={getTheme()}>
      <RestrictedNudgeBottomSheetContent
        modalState={modalState}
        currentScore={currentScore}
        scoreChange={scoreChange}
        action={action}
        onContinue={onContinue}
      />
    </ThemeProvider>
  );
}
